module.exports = __webpack_public_path__ + "assets/img/nljz.77d7a905.png";